import { Component } from '@angular/core';

@Component({
  selector: 'ps-acesso-root',
  templateUrl: './app.component.html',
})
export class AppComponent {}
